import React from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, ArrowUpRight, Mail, Phone } from "lucide-react";
import { BRAND } from "@/lib/site";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/services", label: "Services" },
  { to: "/mechanisms", label: "Mechanisms" },
  { to: "/case-studies", label: "Case Studies" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#FDFDFD]/95 backdrop-blur border-b border-zinc-200"
    >
      {/* Top spec bar */}
      <div className="hidden md:flex items-center justify-end px-6 py-2 bg-[#C2410C] text-[11px] font-mono uppercase tracking-[0.2em] text-white">
        <div className="flex items-center gap-6">
          <span>{BRAND.hours}</span>
          <a
            href={`mailto:${BRAND.email}`}
            className="flex items-center gap-2 text-white hover:text-white/70 transition-colors normal-case tracking-normal"
            data-testid="header-top-email"
          >
            <Mail size={13} strokeWidth={2} className="text-white" />
            <span>{BRAND.email}</span>
          </a>
          <a
            href={`tel:${BRAND.phoneDial}`}
            className="flex items-center gap-2 text-white hover:text-white/70 transition-colors"
            data-testid="header-top-phone"
          >
            <Phone size={13} strokeWidth={2} className="text-white" />
            <span>{BRAND.phone}</span>
          </a>
        </div>
      </div>

      <div className="flex items-center justify-between px-4 md:px-6 py-4">
        <Link to="/" data-testid="header-logo-link" className="flex items-center">
          <img
            src={BRAND.logoUrl}
            alt={BRAND.name}
            className="h-14 md:h-16 w-auto"
            fetchPriority="high"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `nav-link text-[13px] font-medium tracking-wide uppercase text-zinc-900 ${isActive ? "active" : ""}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link to="/contact" className="btn-primary" data-testid="header-cta-enquire">
            Enquire <ArrowUpRight className="arrow" size={14} strokeWidth={2.5} />
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden border border-zinc-900 p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-zinc-200 bg-[#FDFDFD]" data-testid="mobile-menu">
          <div className="flex flex-col p-4 gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm uppercase tracking-wider border-l-2 ${isActive ? "border-[#C2410C] text-zinc-900 bg-zinc-50" : "border-transparent text-zinc-700"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="btn-primary mt-4 justify-center"
              data-testid="mobile-cta-enquire"
            >
              Enquire <ArrowUpRight size={14} strokeWidth={2.5} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
